export const ErrorTypes = {
  UNAUTHORIZED: 401,
};
